<template>
  <div class="about">
    <m-banner :bg="banner.imgUrl" />

    <search-input />

    <nav-list />

    <div class="intro block center-box">
      <m-pane-title title="研究院介绍" sub-title="Introduction" />

      <p class="txt-align" :class="lang === 'en' ? 'en-txt-align' : ''" v-for="(item, i) in (introduction.description || '').split('|')" :key="i">{{item}}</p>
    </div>

    <div class="purpose block">
      <m-pane-title class="center-box" title="研究院宗旨" sub-title="Purpose" />

      <div class="pur-con center-box bg-box">
        <div class="item" v-for="item in purpose" :key="item.id">
          <img :src="item.pcImgUrl" alt="">
          <span>{{item.title}}</span>
          <p>{{item.description }}</p>
        </div>
      </div>
    </div>

    <div class="scope center-box block">
      <m-pane-title title="业务范围" sub-title="Scope of business" />

      <div class="item" v-for="item in business" :key="item.id">
        <img :src="item.pcImgUrl" alt="">
        <div class="txt-box">
          <p>{{item.title}}</p>
          <p :class="lang === 'en' ? 'en-txt-align' : ''">
            {{item.description}}
          </p>
        </div>
      </div>
    </div>

    <!--
    <div class="organizational center-box block">
      <m-pane-title title="组织架构" sub-title="SHJSN Structure" />

      <img src="../../assets/mobile/org.jpg" alt="" v-show="lang === 'zh'">
      <img src="../../assets/mobile/en-org.jpg" alt="" v-show="lang === 'en'">
    </div>
    -->

    <back-home />
  </div>
</template>

<script>
export default {
  name: "About",
  data() {
    return {
      banner: {},
      introduction: {},
      purpose: [],
      business: []
    }
  },
  computed: {
    lang() {
      return this.$store.state.mlang;
    }
  },
  methods: {
    getDataByLang(lang) {
      if(lang === 'zh') {
        this.getData('china');
      } else {
        this.getData('english');
      }
    },
    filterData(records) {
      this.introduction = records['211'][0];
      this.purpose = records['212'];
      this.business = records['213'];
    },
    getData(language) {
      this.$http.getOnlyContent({
        itemType: '2',
        platform: 'pc',
        language
      }).then(res => {
        this.filterData(res.crmOweContentMaps || {});
      });
    },
    getBanner() {
      this.$http.getOnlyContent({
        itemType: '2',
        platform: 'mb',
        language: this.lang === 'zh' ? 'china' : 'english'
      }).then(res => {
        this.banner = res.imageMaps['21'][0];
      });
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler(v) {
        this.getDataByLang(v);
      }
    }
  },
  created() {
    this.getBanner();
  }
}
</script>

<style lang="less">
@import "../../common/theme";
.mobile-home {
  .about {
    .intro {
      >p {
        text-indent: 2em;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .pur-con {
      padding-top: calc(@mobileFont * .55);
      padding-bottom: calc(@mobileFont * .55);
      display: flex;
      justify-content: space-between;
      text-align: center;
      align-items: flex-start;
      background-image: url("../../assets/bg-3.jpg");
      background-size: cover;
      background-position: 50% 50%;
      .item {
        width: calc((100% - 15px) / 2);
      }
      img {
        display: block;
        width: calc(@mobileFont * 1);
        margin: 0 auto 15px;
      }
      span {
        display: inline-block;
        font-size: calc(@mobileFont * .3);
        color: #037698;
        border-bottom: 1px solid #7d7d7d;
        margin-bottom: 20px;
        padding: 0 10px 15px;
        font-weight: bolder;
      }
      p {
        font-size: calc(@mobileFont * .26);
      }
    }
    .scope {
      .item {
        font-size: 0;
        padding: 15px 0;
        & ~ .item {
          border-top: 1px solid #d2d2d2;
        }
        >* {
          display: inline-block;
          vertical-align: top;
        }
        img {
          width: calc(@mobileFont * .8);
          margin-right: 20px;
        }
        p, span {
          font-size: calc(@mobileFont * .28);
        }
        .txt-box {
          width: calc(100% - @mobileFont - 20px);
          p:nth-child(1) {
            font-size: calc(@mobileFont * .30);
            margin-bottom: 5px;
            color: #037698;
            font-weight: bolder;
          }
          p:nth-child(2) {
            text-indent: 2em;
          }
        }
      }
    }
    .organizational {
      img {
        display: block;
        width: 100%;
      }
    }
  }
}
</style>
